var React = require('react');

function Body (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M24.707 19.616h2.195a1.934 1.934 0 0 0 1.896-2.314l-.235-1.176a2 2 0 0 0-1.328-1.505l-3.878-1.293a2 2 0 0 1-.946-.67l-1.645-2.114A4 4 0 0 0 17.552 9l-5.977.085a3.51 3.51 0 0 0-3.138 2.042l-.696 1.512a2 2 0 0 1-.681.81l-2.035 1.403a2 2 0 0 0-.852 1.43l-.163 1.493a1.66 1.66 0 0 0 1.65 1.84h1.39l-.001.075a2.777 2.777 0 1 0 5.552-.074h6.555l-.001.074a2.777 2.777 0 1 0 5.552-.074zm-2.776 5.85a5.774 5.774 0 0 1-4.982-2.85h-2.142a5.774 5.774 0 0 1-4.982 2.85 5.775 5.775 0 0 1-5.028-2.93 4.66 4.66 0 0 1-3.77-5.086l.164-1.494a5 5 0 0 1 2.131-3.574l1.809-1.247.58-1.263a6.51 6.51 0 0 1 5.821-3.786L17.51 6a7 7 0 0 1 5.625 2.701l1.459 1.876 3.59 1.197a5 5 0 0 1 3.322 3.763l.235 1.175a4.934 4.934 0 0 1-4.826 5.903 5.774 5.774 0 0 1-4.983 2.85z"}));
}

Body.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Body;

Body.default = Body;
